import { Text } from '../text/text';
/**
 * 坐标类型
 * @enum {number}
 */
export var CoordinateType;
(function (CoordinateType) {
    //经纬度坐标
    CoordinateType[CoordinateType["Latlng"] = 1] = "Latlng";
    //地理平面坐标
    CoordinateType[CoordinateType["Plane"] = 2] = "Plane";
    //屏幕平面坐标
    CoordinateType[CoordinateType["Screen"] = 3] = "Screen";
})(CoordinateType || (CoordinateType = {}));
/**
 * 图形类型
 * @enum {number}
 */
export var GeometryType;
(function (GeometryType) {
    //点
    GeometryType[GeometryType["Point"] = 1] = "Point";
    //线
    GeometryType[GeometryType["Polyline"] = 2] = "Polyline";
    //面
    GeometryType[GeometryType["Polygon"] = 3] = "Polygon";
    // MultiplePoint = 4,
    // MultiplePolyline = 5,
    // MultiplePolygon = 6
})(GeometryType || (GeometryType = {}));
/**
 * 图形基类
 */
export class Geometry {
    get type() {
        return this._type;
    }
    /**
     * 包络矩形
     * @remarks
     * 注意bound的坐标类型：一般为地理平面坐标，即投影后坐标
     */
    get latlngBounds() {
        return this._latlngBounds;
    }
    get planeBounds() {
        return this._planeBounds;
    }
    get screenBounds() {
        return this._screenBounds;
    }
    get crs() {
        return this._crs;
    }
    set crs(value) {
        this._crs = value;
        this.project();
    }
    /**
     * 图形包络矩形与可见视图范围是否包含或相交
     * @param {Projection} projection - 坐标投影转换
     * @param {Bound} extent - 当前可视范围
     * @return {boolean} 是否在可视范围内
     */
    // intersect(projection: Projection = new WebMercator(), extent: Bound = projection.bound): boolean {
    //     if (!this._projected) this.project(projection);
    //     return extent.intersect(this._bound);
    // }
    /**
     * 获取图形中心点虚函数
     * @param {CoordinateType} type - 坐标类型
     * @param {Projection} projection - 坐标投影转换
     * @return {number[]} 中心点坐标
     */
    getCenter(type = CoordinateType.Latlng) {
        if (type === CoordinateType.Plane) {
            return this._planeBounds.getCenter();
        }
        else if (type === CoordinateType.Screen) {
            return this._screenBounds.getCenter();
        }
        else {
            return this._latlngBounds.getCenter();
        }
    }
    // getCenter(type: CoordinateType = CoordinateType.Latlng, projection: Projection = new WebMercator()) {};
    /**
     * 获取图形包络矩形
     * 针对新建图形，还未进行投影的情况
     * @param {Projection} projection - 坐标投影转换
     * @return {number[]} 包络矩形
     */
    // getBound(projection: Projection = new WebMercator()) {
    //     if (!this._projected) this.project(projection);
    //     return this._bound;
    // };
    /**
     * 获取两个图形间距离
     * @remarks
     * 当前为两图形中心点间的直线距离
     * 多用于聚合判断
     * @param {Geometry} geometry - 另一图形
     * @param {CoordinateType} type - 坐标类型
     * @param {CanvasRenderingContext2D} ctx - 绘图上下文
     * @param {Projection} projection - 坐标投影转换
     * @return {number} 距离
     */
    distance(geometry, type = CoordinateType.Screen) {
        if (type == CoordinateType.Screen || type == CoordinateType.Plane) {
            const center = this.getCenter(type);
            const center2 = geometry.getCenter(type);
            return Math.sqrt((center2.x - center.x) * (center2.x - center.x) + (center2.y - center.y) * (center2.y - center.y));
        }
        else {
            // const center: L = this.getCenter(type) as XY;
            // const center2: XY = geometry.getCenter(type) as XY;
            // return Math.sqrt((center2.x-center.x) * (center2.x-center.x) + (center2.y-center.y) * (center2.y-center.y));
        }
    }
    /**
       * 标注绘制
       * @remarks
       * 标注文本支持多行，/r/n换行
       * @param {string} text - 标注文本
       * @param {CanvasRenderingContext2D} ctx - 绘图上下文
       * @param {Projection} projection - 坐标投影转换
       * @param {SimpleTextSymbol} symbol - 标注符号
       */
    label(ctx, value, symbol = new Text()) {
        if (value == null || value == undefined || value === "")
            return;
        // ctx.save();
        ctx.strokeStyle = symbol.strokeStyle;
        ctx.fillStyle = symbol.fillStyle;
        ctx.lineWidth = symbol.lineWidth;
        ctx.lineJoin = "round";
        ctx.font = symbol.fontSize + "px/1 " + symbol.fontFamily + " " + symbol.fontWeight;
        const center = this.getCenter(CoordinateType.Screen);
        const array = value.toString().split("/r/n");
        let widths = array.map(str => ctx.measureText(str).width + symbol.padding * 2);
        let width = Math.max(...widths);
        let height = symbol.fontSize * array.length + symbol.padding * 2 + symbol.padding * (array.length - 1);
        const screenX = center.x;
        const screenY = center.y;
        let totalX, totalY;
        switch (symbol.placement) {
            case "TOP":
                totalX = -width / 2;
                totalY = -symbol.pointSymbolHeight / 2 - height;
                break;
            case "BOTTOM":
                totalX = -width / 2;
                totalY = symbol.pointSymbolHeight / 2;
                break;
            case "RIGHT":
                totalX = symbol.pointSymbolWidth / 2;
                totalY = -height / 2;
                break;
            case "LEFT":
                totalX = -symbol.pointSymbolWidth / 2 - width;
                totalY = -height / 2;
                break;
        }
        ctx.strokeRect(screenX + totalX, screenY + totalY, width, height);
        ctx.fillRect(screenX + totalX, screenY + totalY, width, height);
        ctx.textBaseline = "top";
        ctx.fillStyle = symbol.fontColor;
        array.forEach((str, index) => {
            ctx.fillText(str, screenX + totalX + symbol.padding + (width - widths[index]) / 2, screenY + totalY + symbol.padding + index * (symbol.fontSize + symbol.padding));
        });
        // ctx.restore();
    }
}
